import { select } from "@fruugo/utilities";
import {
  QUANTITY_CHANGE_EVENT,
  QuantityChangeDetail,
  setQuantity,
} from "./quantity-selector";

export const initQuantityOffer = () => {
  const container = select<HTMLElement>(".js-quantity-offer");
  if (!container) return;

  const options = container.querySelectorAll<HTMLButtonElement>(
    ".js-quantity-offer-option"
  );

  // setQuantity dispatches the change event below, which updates the pressed state.
  options.forEach((option) => {
    option.addEventListener("click", () => {
      setQuantity(Number(option.dataset.quantity));
    });
  });

  // Keep the cards in step with the stepper: a quantity that is neither card leaves both unselected.
  document.addEventListener(QUANTITY_CHANGE_EVENT, (event) => {
    const { quantity } = (event as CustomEvent<QuantityChangeDetail>).detail;

    options.forEach((option) => {
      const pressed = Number(option.dataset.quantity) === quantity;
      option.setAttribute("aria-pressed", String(pressed));
    });
  });
};
